<div class="toast-host" aria-live="polite">
    @if (message) {
        <div class="toast-card toast-card--{{type}}" [attr.role]="type === 'danger' ? 'alert' : 'status'" data-testid="aviso">
            <i class="bi" [class]="icono" aria-hidden="true"></i>
            <p>{{message}}</p>
            <button type="button" class="toast-close" aria-label="Cerrar aviso" (click)="closeAlert()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
        </div>
    }
</div>
